import React from 'react';
import { Carousel } from '../../shared/carousel';
import { homeInfo } from './Settings';
import FmProSection from './FmProSection';
import OurSolutionsSection from './OurSolutionsSection';
import BuildingSystemModulesSection from './BuildingSystemModulesSection';
import AboutUsSection from './AboutUsSection';
import NewsSection from '../news/NewsSection';
import NewsDetailModal from '../news/NewsDetailModal';
import PublishedArticlesSection from '../news/PublishedArticlesSection';
import ProductArticlesSection from './ProductArticlesSection';
import PageNavigation from '../../shared/page-navigation';
import CustomerSaySection from '../customer-say/CustomerSaySection';

const HomePage = () => {
  return (
    <div>
      <PageNavigation {...homeInfo.navigation} />
      <div className="">
        <Carousel {...homeInfo.landingCarousel} />
      </div>
      <FmProSection {...homeInfo.fmPro} />
      <CustomerSaySection {...homeInfo.customerSay} />
      <OurSolutionsSection {...homeInfo.ourSolutions} />
      <BuildingSystemModulesSection {...homeInfo.buildingSystemModules} />
      <AboutUsSection {...homeInfo.aboutUs} />
      <NewsSection {...homeInfo.newsAndHighlights} />
      <PublishedArticlesSection {...homeInfo.publishedArticles} />
      <ProductArticlesSection {...homeInfo.productArticles} />
      <NewsDetailModal />
    </div>
  );
};

export default HomePage;